<template>
    <div class="modal-body">

        <template v-for="(item, index) in items">

            <!-- control_item -->
            <div class="row control_item underlined_item">
                <div class="col-12 col-md-9 col-xl-10 mt_xxs">

                    <div class="media control_group">
                        <div class="control_action">
                            <button href="#" class="btn btn_lg btn_common btn_icontext"
                                @click.prevent="chooseDelivery(item)"
                                :disabled="disabled(item)">
                                <i class="f7-icons icon_lg">
                                    {{ delivery.id == item.id ? 'checkmark_alt_circle_fill' : 'checkmark_alt_circle' }}
                                </i>
                                    {{ delivery.id == item.id ? 'Выбрано' : 'Выбрать' }}
                            </button>
                        </div>

                        <div class="media-body">
                            <div class="control_title subtitle">{{ item.name }}</div>

                            <div class="control_small small_info" v-html="item.info">
                            </div>
                            <div v-if="item.address" class="control_info item_info item_info_horizontal">
                                <p v-html="'<span>Адрес</span> ' + item.address"></p>
                            </div>
                            <div v-if="item.min_order_price > 0" class="control_info item_info item_info_horizontal">
                                <p v-html="'<span>Минимальная сумма заказа</span> ' + item.min_order_price"></p>
                            </div>
                            <div v-if="item.work_schedule || item.phone" class="control_info item_info item_info_horizontal">
                                <p v-if="item.work_schedule"><span>График работы</span> {{ item.work_schedule }}</p>
                                <p v-if="item.phone"><span>Тел.</span> {{ item.phone }}</p>
                            </div>
                            <div v-if="item.delivery_schedule" class="control_info item_info item_info_horizontal">
                                <p><span>График доставки</span> {{ item.delivery_schedule }}</p>
                            </div>
                            <div v-if="item.shipping_companies" class="control_info item_info item_info_horizontal">
                                <p v-html="item.shipping_companies"></p>
                            </div>
                            <div v-if="item.tariff" class="control_info item_info item_info_horizontal">
                                <p><span>Тарифы</span> {{ item.tariff }}</p>
                            </div>
                            <div v-if="item.conditions" class="control_info item_info item_info_horizontal">
                                <p><span>Условия</span> {{ item.conditions }}</p>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-12 col-md-3 col-xl-2 mt_xxs">

                </div>
            </div>
            <!-- //control_item -->

        </template>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
        }
    },
    methods: {
        chooseDelivery(item) {
            this.$store.dispatch("order/chooseDelivery", item);
            document.getElementById("modalDeliveryClose").click();
        },

        // Доступен ли способ доставки
        disabled(item) {
            // Ограничения по минимальной стоимости заказа
            if (item.min_order_price > 0 && item.min_order_price > this.$store.state.cart.amount) {
                return true;
            }

            // Ограничения для физ. лиц, юр. лиц и ИП
            return (!(
                item.available_for_le && this.payer.type === 1
                || item.available_for_ie && this.payer.type === 2
                || item.available_for_np && this.payer.type === 3
            ));
        },
    },
    computed: {
        // Массив способов доставки
        items() {
            return this.$store.state.delivery.deliveries;
        },

        // Выбранный способ доставки
        delivery() {
            return this.$store.state.order.delivery;
        },

        // Выбранный плательщик
        payer() {
            return this.$store.state.order.payer;
        },
    },
};
</script>
